import axios from 'axios';
const { CTL_URL, AUTH_URL, EVENT_URL } = process.env;

const ctl = axios.create({
  baseURL: CTL_URL + '/api'
});

const auth = axios.create({
  baseURL: AUTH_URL
});

const events = axios.create({
  baseURL: EVENT_URL
});

const getHeaders = () => ({
  Authorization: `Bearer ${localStorage.token}`
})

export const postToken = (username, password) => {
  return auth.post('/oauth/token', {
    username,
    password,
    grant_type: 'password'
  }).then(({ data }) => data)
}

export const getUserProfile = () =>
  auth.get('/api/me', { headers: getHeaders() }).then(({ data }) => data);

export const getOrganisations = () =>
  ctl.get('/organisations?per_page=5000', { headers: getHeaders() }).then(({ data }) => data);

export const getDevices = (organisationId) =>
  ctl.get(`/organisations/${organisationId}/devices?all=true`, { headers: getHeaders() }).then(({ data }) => data);

// CTL is not understanding PATCH method, but it looks like PUT is acting as patch anyway.
// This function is also called for updating single attributes e.g: { id: 123, profile_id: 321 }.
export const putDevice = (organisationId, device) =>
  ctl.put(`/devices/${device.id}`, device, { headers: getHeaders() })
    .then(({ data }) => data);

export const getEvents = (organisationId) =>
  events.get(`/organisations/${organisationId}/events?expand=true`, { headers: getHeaders() })
    .then(({ data }) => data.map(transformEvent));

export const postEvent = (organisationId, event) =>
  events.post(`/organisations/${organisationId}/events`, event)
    .then(({ data }) => transformEvent(data))
  //events.get(`/organisations/${organisationId}/events`).then(({ data }) => data);

export const postSchedule = (eventId, schedule) =>
  events.post(`/events/${eventId}/schedules`, schedule)
    .then(({ data }) => data)
    .then(addEmptyDeviceAddresses);

export const postDeviceToSchedule = (eventId, scheduleId, deviceAddress) => {
  return events.put(`/events/${eventId}/schedules/${scheduleId}/devices`, { device_address: deviceAddress })
    .then(({ data }) => data);
}

export const putSchedule = (eventId, schedule) =>
  events.put(`/events/${eventId}/schedules/${schedule.id}`, schedule)
    .then(({ data }) => data);

export const publishEvent = (organisationId, eventId) =>
  events.post(`/organisations/${organisationId}/events/${eventId}/publish`)
    .then(({ data }) => data);

export const postProfile = (organisationId, profile) =>
  ctl.post(`/profiles`, { ...profile, organisation_id: organisationId }, { headers: getHeaders() })
    .then(({ data }) => data)
    .then(addMultiProperty)
    .catch(err => Promise.reject(err.response ? { full_messages: err.response.data.error.split(", ") } : { full_messages: err }));

export const putProfile = (organisationId, profile) =>
  ctl.put(`/profiles/${profile.id}`, profile, { headers: getHeaders() })
    .then(({ data }) => data)
    .then(addMultiProperty)
    .catch(err => Promise.reject(err.response ? { full_messages: err.response.data.error.split(", ") } : { full_messages: err }));

export const getProfiles = (organisationId) =>
  ctl.get(`/organisations/${organisationId}/profiles?all=true`, { headers: getHeaders() })
    .then(({ data }) => data)
    .then(profiles => profiles.map(addMultiProperty));

export const getProfile = (organisationId, profileId) =>
  ctl.get(`/profiles/${profileId}?all=true`)
  //ctl.get(`/organisations/${organisationId}/profiles/${profileId}?all=true`)
    .then(({ data }) => data)
    .then(profile => addMultiProperty(profile));

function addMultiProperty(profile) {
    if(profile.brightness)
      profile['multi'] = Object.keys(profile.brightness).length > 1;
    return profile;
}

function addEmptyDeviceAddresses(schedule) {
  return { ...schedule, device_addresses: []}
}

function transformEvent(event) {
  return { ...event, allDay: true, start: event.event_date, end: event.event_date }
}



// WEBPACK FOOTER //
// ./src/api.js